import {Button, closeCurrentDialog} from 'platform/components';
import {Box, Right, VStack} from 'platform/foundation';

import {useState} from 'react';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {useRenderCustomerMessageEmailTemplateV2Mutation} from '@dms/api/core';
import i18n from '@dms/i18n';
import {EmailWindow, handleApiError, localeByLanguage} from '@dms/shared';

import {RequiredTestIdProps, suffixTestId, useOnMount} from 'shared/web';

const FALLBACK_LOCALE = 'en-GB';
const PREVIEW_HEIGHT = 180;

interface AutomatedCommunicationEmailPreviewProps extends RequiredTestIdProps {
  customerMessageId: 'ai_lead-business_case_online_offer' | 'ai_lead-interest_offer';
}

export function AutomatedCommunicationEmailPreview(props: AutomatedCommunicationEmailPreviewProps) {
  const [renderEmail, {isLoading}] = useRenderCustomerMessageEmailTemplateV2Mutation();

  const [htmlData, setHtmlData] = useState<string | null>(null);

  const renderPreview = () =>
    renderEmail({
      customerMessageId: props.customerMessageId,
      renderCustomerMessageRequestBodyV2: {
        locale: localeByLanguage[i18n.language] ?? FALLBACK_LOCALE,
        customerId: null,
        payload: {
          customerMessageId: props.customerMessageId,
          context: null,
        },
      },
    })
      .unwrap()
      .then((data) => data.body)
      .then(setHtmlData)
      .catch(handleApiError);

  useOnMount(renderPreview);

  return (
    <VStack spacing={4}>
      <Box position="relative" height={PREVIEW_HEIGHT} maxHeight="80vh">
        <VStack height="100%">
          <Box position="relative" height="100%">
            <EmailWindow
              htmlData={htmlData}
              isRerendering={isLoading && isNotNilOrEmpty(htmlData)}
              data-testid={suffixTestId('emailWindow', props)}
            />
          </Box>
        </VStack>
      </Box>

      <Right>
        <Button
          title={i18n.t('general.actions.close')}
          onClick={closeCurrentDialog}
          variant="secondary"
          data-testid={suffixTestId('close', props)}
        />
      </Right>
    </VStack>
  );
}
